// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ib-0";
export var headerCellHover = "_ib-1";
export var readCellContainer = "_ib-2";
export var unreadIndicator = "_ib-3";